import React, { useEffect } from "react";
import styled from "styled-components";
//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

import { mobile, mobileM, tablet } from "../../responsive";
const imgSavoirFaire =
  "https://images.pexels.com/photos/6627105/pexels-photo-6627105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
//
//
const SavoirFaireContainer = styled.div`
  border-radius: 50px;
  overflow: hidden;
  width: 100%;
  min-height: 60vh;

  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: rgb(243, 243, 243);

  //
  ${mobile({ flexDirection: "column" })}
  ${mobileM({ flexDirection: "column" })}
  ${tablet({ flexDirection: "column" })}
`;
//

// ** LEFT **
//
const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

//
//

const ImgContainer = styled.div``;
const ImgBox = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  overflow: hidden;

  //
  img {
    width: 100%;
    min-height: auto;
    object-fit: cover;

    //
    ${mobile({ borderRadius: "0" })}
    ${mobileM({ borderRadius: "0" })}
  ${tablet({ borderRadius: "0" })}

   //
  }
`;
//
//
const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
//
const Container = styled.div`
  padding: 50px;
  ${mobile({
    padding: "70px 30px",
  })}
  ${mobileM({
    padding: "70px 40px",
  })}
   ${tablet({
    padding: "70px 50px",
  })}
  //
  //
  h1,
  h2,
  h3 {
    padding: 0 0 0 0;
    color: #0f0f0ff6;
    font-size: calc(6px + 1vmin);
    text-transform: uppercase;
    font-family: "Poppins-light";
    letter-spacing: 1px;
  }
  h2 {
    margin: 0 50% 0 0;
    padding: 10px 0 30px 0;
    color: #0f0f0f;
    font-size: calc(10px + 4vmin);
    text-transform: Capitalize;
    line-height: 42px;
    ${mobile({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
    ${mobileM({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
        ${tablet({
      padding: "25px 0 30px 0",
      lineHeight: "35px",
      margin: "0 20% 0 0",
    })}
  }
  p {
    color: #0f0f0fcf;
    margin: 0 0 40px 0;
    font-size: calc(7px + 1vmin);
    ${mobile({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "25px",
    })}
    ${mobileM({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
      ${tablet({
      margin: "0 0 50px 0",
      textAlign: "left",
      fontSize: "calc(9px + 1.4vmin)",
      lineHeight: "calc(19px + 1.4vmin)",
    })}
  }

  button {
    padding: 13px 35px;
    margin: 0;
    font-weight: 600;
    font-size: calc(7px + 1vmin);
    border-radius: 100px 100px 100px 100px;
    background-color: transparent;
    border: 1.5px solid #0f0f0f;
    color: #0f0f0f;
    text-transform: uppercase;

    transition: 0.3s ease-in-out;
    &:hover {
      padding: 13px 35px;
      margin: 0;
      background-color: rgb(10, 10, 10);
      border: 1.5px solid rgb(24, 24, 24);
      font-weight: 100;
      color: #eeeeee;
    }
  }
`;

//
//

const SavoirFaire = () => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  return (
    <>
      <SavoirFaireContainer>
        <Left>
          <ImgContainer>
            <ImgBox>
              <motion.img
                data-aos="fade-right"
                whileHover={{ scale: 1.1 }}
                onHoverStart={(eImg) => {}}
                onHoverEnd={(eImg) => {}}
                src={imgSavoirFaire}
              />
            </ImgBox>
          </ImgContainer>
        </Left>
        <Right>
          <Container>
            <h1>Introduction</h1>
            <h2>re-inventing traditional</h2>
            <p>
              For six generations of French designers, Fluxus22 has offered
              timeless and avant-garde creation which combines artistic and
              architectural inspirations with the exceptional know-how of the
              Saint Germain des Pres.
            </p>
            <button>Read More</button>
          </Container>
        </Right>
      </SavoirFaireContainer>
    </>
  );
};

export default SavoirFaire;
